<template>
    <div>
        <v-container class="px-2 pb-2 mt-6">
            <v-row class="mt-n7" no-gutters justify="space-between">
                <v-col cols="auto">
                    <v-btn icon>
                        <app-icon
                            :active="activeFilter"
                            icon="filter"
                            :clickable="true"
                            @click="filterBtnClick"
                        />
                    </v-btn>
                </v-col>

                <v-img
                    class="mx-auto"
                    width="154"
                    style="max-width: 154px"
                    src="@/assets/images/logo/noodzly-logo.png"
                />

                <v-col cols="auto">
                    <v-btn icon>
                        <router-link :to="{ name: 'user.own.profile.wallet' }">
                            <app-icon :clickable="true" icon="wallet" />
                        </router-link>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

        <!--        <home-swiper :title="$t('pages.app.home.subscribed')" :items="subscribeds" v-if="!!subscribeds && Object.values(subscribeds).length" @click="showStory"/>-->
        <div class="custom-tabs">
            <div
                v-for="(tab, i) in tabs"
                :key="i"
                :class="['custom-tab', { active: activeTab === i }, { 'stream-active': activeTab === i && tab === 'Streams' }]"
                @click="onTabClick(i)"
            >
                {{ tab.toString() }}
            </div>
        </div>
        <swiper ref="outerSwiper" 
                :options="{ 
                    on: {slideChange: onOuterSwiperChange},
                    initialSlide: activeTab,
                    slidesPerView: 1,
                }"
        >
            <swiper-slide v-for="(tab, i) in tabs" :key="i">
                <div class="w-full stream-block" v-if="activeTab === i">
                    <template v-if="tab == 'Streams'">

                        <template v-if="
                            !subscriptionsWithStream.length &&
                            !followingWithStream.length &&
                            !discoversWithStream.length
                        ">
                            <div class="text-center py-4 text-muted">
                                No streams are available
                            </div>
                        </template>

                        <home-swiper
                            class="mb-2"
                            :title="$t('pages.app.home.subscribed')"
                            :items="subscriptionsWithStream"
                            v-if="subscriptionsWithStream.length"
                            :refClass="true"
                            :circle="true"
                            :streamIcon="true"
                        />
                        <home-swiper
                            class="mb-2"
                            :title="$t('pages.app.home.following')"
                            :items="followingWithStream"
                            v-if="followingWithStream.length"
                            :refClass="true"
                            :circle="true"
                            :streamIcon="true"
                        />
                        <home-discover
                            class="mb-2"
                            :title="$t('pages.app.home.discover')"
                            :items="discoversWithStream"
                            v-if="discoversWithStream.length"
                            :refClass="true"
                            :circle="true"
                            :streamIcon="true"
                        />
                    </template>
                    <template v-else>

                        <template v-if="
                            !Object.values(subscriptions || {}).length &&
                            !Object.values(filteredFollowing || {}).length &&
                            !Object.values(filteredDiscovers || {}).length
                        ">
                            <div class="text-center py-4 text-muted">
                                No stories are available
                            </div>
                        </template>

                        <home-swiper
                            class="mb-2"
                            :title="$t('pages.app.home.subscribed')"
                            :items="subscriptions"
                            v-if="subscriptions && Object.values(subscriptions).length"
                            @click="showStory"
                        />
                        <home-swiper
                            class="mb-2"
                            :title="$t('pages.app.home.following')"
                            :items="filteredFollowing"
                            v-if="filteredFollowing && Object.values(filteredFollowing).length"
                            @click="showStory"
                        />
                        <home-discover
                            class="mb-2"
                            :title="$t('pages.app.home.discover')"
                            :items="filteredDiscovers"
                            v-if="filteredDiscovers && Object.values(filteredDiscovers).length"
                            @click="showStory"
                        />                   
                    </template>
                </div>
            </swiper-slide>
        </swiper>
        <app-transition>
            <filter-home
                v-if="isShowFilters"
                @close="isShowFilters = false"
                @reset="resetFilters"
                @save="setFilters"
            ></filter-home>
        </app-transition>                        
        <Observer @intersect="loadMore" />
        <story-view
            v-if="isStoryShow"
            @close="handleCloseStory"
            @prevUserStory="handlePrevUserStory"
            @nextUserStory="handleNextUserStory"
            @reload-story="handleReloadStory"
        />
    </div>
</template>

<script>
import HomeSwiper from "@/components/app/home/HomeSwiper";
import HomeDiscover from "@/components/app/home/HomeDiscover";
import FilterHome from "@/components/app/home/FilterHome";
import StoryView from "@/views/app/story/StoryView";
import { mapActions, mapState } from "vuex";
import Observer from "@/components/app/Observer";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
    name: "Home",
    components: {
        FilterHome,
        HomeSwiper,
        HomeDiscover,
        StoryView,
        Observer,
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            activeTab: 0,
            tabs: ["Stories", "Streams"],
            isShowFilters: false,
            isStoryShow: false,
            activeFilter: false,
            filters: {
                sections: ["subscribed", "following", "discover"],
                range: [18, 100],
                panel: "",
                tags: [],
                activeGenders: [],
            },
            postingStep: this.$store.state.story.isShowCameraScreen.step,
            usersStories: [],
            prevIndexUsersStories: 0,
            currentIndexUsersStories: 0,
            nextIndexUsersStories: 0,
            page: 1,
            perPageLimit: 0,
            estimatedRecordHeight: 0,
            timer: null,
            tabSwiperOptions: {
                slidesPerView: 'auto',
                freeMode: true,
                allowTouchMove: true,
            },
            contentSwiperOptions: {
                autoHeight: true,
                allowTouchMove: true,
            },
        };
    },
    computed: {
        ...mapState({
            subscriptions: (state) => state.user.user.subscriptions,
            streamsubscriptions: (state) => state.user.user.streamsubscriptions,
            discoversstreams: (state) => state.user.user.discoversstreams,
            following: (state) => state.user.user.following,
            discovers: (state) => state.user.user.discovers,
            isStoryData: (state) => state.user.user.isStoryData,
            currenUser: (state) => state.user.user.data,
            loader: (state) => state.site.loader,
        }),
        filteredFollowing() {
            if (this.subscriptions?.length) {
                const subscriptionIds = new Set(
                    this.subscriptions?.map((sub) => sub.id)
                );
                return this.following?.filter(
                    (item) => !subscriptionIds?.has(item.id) && item.has_stories !== 0
                );
            }
            return this.following?.filter((item) => item.has_stories !== 0);
        },
        filteredDiscovers() {
            if (this.subscriptions?.length && this.discovers?.length) {
                const subscriptionIds = new Set(
                    this.subscriptions?.map((sub) => sub.id)
                );
                return this.discovers?.filter(
                    (item) => !subscriptionIds?.has(item.id)
                );
            }
            return this.discovers;
        },
        subscriptionsWithStream() {
            if (Array.isArray(this.streamsubscriptions)) {
                return this.streamsubscriptions.filter(user =>
                    !!user.stream
                );
            }
            return [];
        },
        followingWithStream() {
            if (!Array.isArray(this.following)) return [];

            const subscriptionIds = new Set(this.streamsubscriptions?.map(sub => sub.id));

            return this.following.filter(user =>
                !!user.stream &&
                !subscriptionIds.has(user.id)
            );
        },
        discoversWithStream() {
            if (!Array.isArray(this.discoversstreams)) return [];

                const subscriptionIds = new Set(this.streamsubscriptions?.map(sub => sub.id));

                return this.discoversstreams.filter(user =>
                    !!user.stream &&
                    !subscriptionIds.has(user.id)
                );
            },
        },
    methods: {
        ...mapActions([
            "getStory",
            "getOwnSubscriptions",
            "getOwnStreamSubscriptions",
            "getOwnFollowers",
            "getOwnFollowing",
            "getOwnStreamDiscovers",
            "getOwnDiscovers",
            "getCountries",
            "getTags",
            "fetchUserCategories"
        ]),

        onTabClick(i) {
            this.activeTab = i;
            const swiperInstance = this.$refs.outerSwiper?.swiper || this.$refs.outerSwiper?.$swiper;
            if (swiperInstance) {
            swiperInstance.slideTo(i);
            }
        },
        onContentSlideChange() {
            const idx = this.$refs.contentSwiper.$swiper.activeIndex
            this.activeTab = idx
            this.$refs.tabSwiper.$swiper.slideTo(idx)
        },

        showStory(model) {
            const ageVerify = this.$core.storyCore.ageVerification(this.currentUser);
            if(ageVerify) {
                this.usersStories = model.items;
                this.currentIndexUsersStories = model.index;
                this.setNeighborUserIndex();
                this.loadStory();
            }
        },
        async loadMore() {
            if (this.isStoryShow) return;
            if (this.isStoryData && this.page > 1) {
                await this.getOwnDiscovers({ ...this.filters, isExistStory: 1, page: this.page, limit: this.perPageLimit });
                await this.getOwnStreamDiscovers({ ...this.filters, page: this.page, limit: this.perPageLimit });
                this.page++;
            }
        },

        async setFilters(e) {
            this.isShowFilters = false;
            this.filters = e;
            this.page = 1;
            await this.loadData();
            this.activeFilter = true;
        },
        async resetFilters(e) {
            this.isShowFilters = false;
            this.filters = e;
            this.page = 1;
            await this.loadData();
            this.activeFilter = false;
        },
        async loadData() {
            await this.getOwnSubscriptions({ ...this.filters });
            await this.getOwnFollowing({ ...this.filters });
            await this.getOwnDiscovers({ ...this.filters, isExistStory: 1, page: this.page, limit: this.perPageLimit });
            await this.getOwnStreamSubscriptions({ ...this.filters });
            await this.getOwnStreamDiscovers({ ...this.filters, page: this.page, limit: this.perPageLimit });
            this.page++;
        },
        setNeighborUserIndex() {
            this.prevIndexUsersStories =
                this.currentIndexUsersStories === 0
                    ? null
                    : this.currentIndexUsersStories - 1;
            this.nextIndexUsersStories =
                this.currentIndexUsersStories === this.usersStories.length - 1
                    ? null
                    : this.currentIndexUsersStories + 1;
        },
        handlePrevUserStory() {
            if (this.prevIndexUsersStories === null) {
                return this.handleCloseStory();
            }
            this.currentIndexUsersStories = this.prevIndexUsersStories;
            this.setNeighborUserIndex();
            this.loadStory();
        },
        handleNextUserStory() {
            if (this.nextIndexUsersStories === null) {
                return this.handleCloseStory();
            }
            this.currentIndexUsersStories = this.nextIndexUsersStories;
            this.setNeighborUserIndex();
            this.loadStory();
        },
        handleCloseStory() {
            this.page = 1;
            this.loadData();
            this.isStoryShow = false;
        },
        async loadStory() {
            const id =
                this.usersStories[this.currentIndexUsersStories].id || null;
            if (id) {
                this.getStory({ id }).then(() => {
                    this.isStoryShow = true;
                });
            }
        },
        handleReloadStory() {
            this.loadStory();
        },
        async refreshDiscovery() {
            this.page = 1;
            await this.getOwnDiscovers({ ...this.filters, isExistStory: 1, page: this.page, limit: this.perPageLimit });
            this.page++;
        },

        filterBtnClick() {
            this.isShowFilters = true;

            this.$mixpanel.identifyUser(this.currenUser.email);
            this.$mixpanel.click('Filter', 'Home Screen');
        },
        onOuterSwiperChange() {
            const swiperInstance = this.$refs.outerSwiper?.swiper || this.$refs.outerSwiper?.$swiper;
            if (swiperInstance) {
                this.activeTab = swiperInstance.realIndex;
            }
        },
    },
    watch: {
        activeTab(val) {
            if (this.$refs.outerSwiper?.swiper) {
            this.$refs.outerSwiper.swiper.slideTo(val);
            }
        },
    },
    destroyed() {
        clearInterval(this.timer);
    },
    async mounted() {
        const homeFilters = localStorage.getItem("home_filters");
        if (homeFilters) {
            this.activeFilter = true;
            this.filters = JSON.parse(homeFilters);
        }
        // Preload tags, categories and countries so FilterHome popup has data when opened
        Promise.all([
            this.getTags(),
            this.getCountries(),
            this.fetchUserCategories()
        ]);
        this.estimatedRecordHeight = 50;
        this.perPageLimit = Math.ceil(Math.floor(window.innerHeight / this.estimatedRecordHeight) / 3) * 3;
        await this.loadData();
        this.timer = setInterval(this.refreshDiscovery, 180000);
    },
};
</script>

<style>
.tab-swiper .swiper-slide.active {
  font-weight: bold;
  border-bottom: 2px solid #1976d2;
}

.subscribed-section {
  padding: 12px 8px 8px 8px;
  margin: 0 8px 16px 8px;
  position: relative;
  background: transparent;
}

.subscribed-label {
  text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 2px;
  margin-bottom: 8px;
}

.stories-row {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  padding: 8px 0;
}
.story-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 8px;
}
.story-avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 3px solid orange;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #222;
}
.story-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.story-username {
  margin-top: 6px;
  color: #fff;
  font-size: 14px;
  text-align: center;
}
.section-header {
  display: flex;
  align-items: center;
  margin: 16px 0 8px 0;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 2px;
}
.section-header span {
  flex-shrink: 0;
  margin-right: 8px;
}
.section-line {
  flex-grow: 1;
  height: 1px;
  background: #fff;
  opacity: 0.3;
  margin-left: 8px;

}
.custom-tabs {
  display: flex;
  justify-content: center;
  /* background-color: #1a1a1a; */
  padding: 10px 0;
  /* margin-top: 16px; */
  /* border-bottom: 1px solid #444; */
}

.custom-tab {
  flex: 1;
  text-align: center;
  font-size: 15px;
  color: #aaa;
  padding: 10px 0;
  font-weight: 500;
  position: relative;
  cursor: pointer;
  transition: all 0.3s;
}

.custom-tab.active {
  color: #fff;
  font-weight: bold;
}

.custom-tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 25%;
  width: 50%;
  height: 2px;
  background-color: #ff8000;
  border-radius: 1px;
}

.custom-tab.stream-active::after {
  background-color: #930000 !important;
}

.stream-block { 
    height: calc(100vh - 212px);
    overflow-y: auto;
}


</style>
